import React, { FC } from 'react';
import styled from 'styled-components';
import { FontWeight, TextAlign, TextColor, TEXT_ALIGN, TEXT_COLOR } from 'styles/constants';

interface Props {
	children?: React.ReactNode;
}

const StyledTitle = styled.h3`
	color: ${({ theme }) => theme.colors.text1};
	display: block;
	text-transform: none;
	line-height: px;
	font-size: 22px;
	text-align: center;
	white-space: normal;
	font-weight: 700;
	position: fixed;
	left: 20px;
	width: calc(100% - 40px);
	z-index: 10;
	padding-bottom: 20px;
	background: ${({ theme }) => theme.colors.bg1};
`;

export const TitleFixed: FC<Props> = props => {
	return <StyledTitle {...props}>{props.children}</StyledTitle>;
};
